import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { ShellComponent } from '../../ui/display/local-shell.component';
import { CmsHotspotsWrapperComponent } from '../hotspots/wrapper/hotspots-wrapper.component';
import { CMS_COMPONENT_IMAGE_WITH_HOT_SPOTS_CONFIG } from './cms-image-with-hot-spots.config';
import { NCmsImageWithHotSpots } from './cms-image-with-hot-spots.interface';

@ICmsComponent<CmsImageWithHotSpotsComponent>(CMS_COMPONENT_IMAGE_WITH_HOT_SPOTS_CONFIG)
@Component({
    standalone: true,
    selector: 'cms-image-with-hot-spots',
    templateUrl: './cms-image-with-hot-spots.component.html',
    styleUrl: './cms-image-with-hot-spots.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:[CmsHotspotsWrapperComponent, NgClass, ShellComponent, ImageModule]
})
export class CmsImageWithHotSpotsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsImageWithHotSpots.IComponentData;
}
